export default __webpack_public_path__ + "static/media/exclusiveClement.ec499095.jpg";